import React from "react";
import { useNavigate, Link } from "react-router-dom";

const NavBarDropDown = ({ user, setUser, isLogged, setIsLogged }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    setUser(null);
    setIsLogged(false);
    navigate("/auth/login");
  };

  // Determine if user data exists
  const hasUserData = user && Object.keys(user).length > 0;

  return (
    <div className="hidden group-hover:block absolute right-0 xl:right-0 w-72 translate-y-8 shadow-xl border-0 rounded-lg bg-_white overflow-hidden z-50">
      {/* Header & User Profile Section */}
      {hasUserData && (
        <div className="relative w-full bg-_bg_dark py-6 px-4">
          <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://your-pattern-url.com/pattern.svg')]"></div>
          <div className="relative flex items-center gap-4 z-10">
            <div className="flex-shrink-0">
              <div className="p-0.5 bg-_white rounded-full shadow-md">
                <img
                  src={user.profileImg}
                  alt="Profile"
                  className="rounded-full w-14 h-14 object-cover"
                  referrerPolicy="no-referrer"
                />
              </div>
            </div>
            <div className="flex-grow">
              <h2 className="text-_white font-semibold text-base">
                {user.firstName + " " + user.lastName}
              </h2>
              <p className="text-_gray_lite text-xs truncate max-w-xs">
                {user.email}
              </p>
              <Link
                to="/profile"
                className="inline-block mt-1 text-xs text-_white hover:underline font-medium"
              >
                View Profile
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* Menu Options */}
      <div className="py-3">
        <div className="w-full flex flex-col text-_dark">
          {hasUserData && (
            <>
              <div className="px-4 pb-2 mb-1">
                <span className="text-xs uppercase font-bold text-_dark_lite tracking-wider">
                  Quick Links
                </span>
              </div>

              {user?.isAdmin == 1 && (
                <Link
                  to="/admin"
                  className="flex items-center px-4 py-2.5 hover:bg-_gray_hover transition-colors duration-150"
                >
                  <span className="text-sm font-medium">Dashboard</span>
                </Link>
              )}

              <Link
                to="/profile"
                className="flex items-center px-4 py-2.5 hover:bg-_gray_hover transition-colors duration-150"
              >
                <span className="text-sm font-medium">Profile</span>
              </Link>

              <Link
                to="/cart"
                className="flex items-center px-4 py-2.5 hover:bg-_gray_hover transition-colors duration-150"
              >
                <span className="text-sm font-medium">Cart</span>
              </Link>

              <Link
                to="/profile/orders"
                className="flex items-center px-4 py-2.5 hover:bg-_gray_hover transition-colors duration-150"
              >
                <span className="text-sm font-medium">My Orders</span>
              </Link>

              <div className="my-2 border-t border-_gray_lite"></div>
            </>
          )}

          <div className="px-4 pb-2 mb-1">
            <span className="text-xs uppercase font-bold text-_dark_lite tracking-wider">
              {!hasUserData && "Get Started"}
            </span>
          </div>

          {!hasUserData && (
            <div className="px-4 py-2 text-sm text-_dark_lite">
              Create an account or log in to access all features.
            </div>
          )}
        </div>
      </div>

      {/* Footer Actions */}
      <div className="p-4 border-t border-_gray_lite bg-_gray_hover">
        {!isLogged ? (
          <div className="grid grid-cols-2 gap-3">
            <Link to="/auth/login" className="col-span-1">
              <button className="w-full px-4 py-2.5 text-_dark border border-_dark border-opacity-20 rounded-md bg-_white hover:bg-opacity-90 transition-all duration-200 text-sm font-medium">
                Sign In
              </button>
            </Link>
            <Link to="/auth/register" className="col-span-1">
              <button className="w-full px-4 py-2.5 text-_white bg-_blue hover:bg-opacity-90 rounded-md transition-all duration-200 text-sm font-medium shadow-sm">
                Register
              </button>
            </Link>
          </div>
        ) : (
          <button
            onClick={handleLogout}
            className="w-full px-4 py-2.5 text-_dark border border-_gray border-opacity-30 rounded-md bg-_white hover:bg-_gray_lite transition-all duration-200 text-sm font-medium"
          >
            Sign Out
          </button>
        )}
      </div>
    </div>
  );
};

export default NavBarDropDown;